export const api_host = {
  test: 'https://partner-test.revieve.com',
  prod: 'https://partner.revieve.com',
  cn: 'https://partner.revieve.cn'
};

export const default_environment = 'test';

export const user_id = 'instoreuser';


// WEBPACK FOOTER //
// ./src/AppConf.js